import { createContext } from 'react';

import { RffFormState } from '../types';

export const RffFormContext = createContext<RffFormState>({} as never);
